import { render, staticRenderFns } from "./DowngradeSubscriptionModal.vue?vue&type=template&id=7b4141fc&"
import script from "./DowngradeSubscriptionModal.vue?vue&type=script&lang=js&"
export * from "./DowngradeSubscriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports